import styles from '../styles/DefaultLoader.module.scss';

export const DefaultLoader = (props) => {
  const { children, centered } = props;

  return (
    <div className={`${styles.container} ${centered ? `${styles.centered}` : ''}`}>
      {props.head || null} {children}
    </div>
  );
};
